import styled from 'styled-components';
import { ColorNeutralDarkGrey, Spacing8, Spacing16 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import PageAction from 'components/shared/Routing/PageAction';
import { removeLinkTextDecoration, removeListStyling } from 'modules/helpers/mixins';
import type { TypeArticleTemplateDetailed, TypeTopicDetailed } from 'types/autogen/contentful';

// #region Styles
const ListOfTopics = styled.ul`
    ${removeListStyling}

    display: flex;
    gap: ${Spacing8};
    flex-wrap: wrap;
`;

const TopicAnchor = styled(PageAction)`
    display: inline-block;
    border: 1px solid ${ColorNeutralDarkGrey};
    color: ${ColorNeutralDarkGrey};
    padding: ${Spacing8} ${Spacing16};

    ${removeLinkTextDecoration};
`;
// #endregion Styles

function Topic(props: TypeTopicDetailed) {
    const {
        fields: { publicName, topicLink }
    } = props;
    if (!topicLink) return;

    return (
        <TopicAnchor action={topicLink}>
            <Typography.Body size="L" strong as="span">
                {publicName}
            </Typography.Body>
        </TopicAnchor>
    );
}

export default function TopicList({
    topics
}: {
    topics: NonNullable<TypeArticleTemplateDetailed['fields']['topics']>;
}) {
    return (
        <ListOfTopics>
            {topics.map((topic) => {
                if (!topic) return;
                return (
                    <li key={topic?.sys.id}>
                        <Topic {...topic} />
                    </li>
                );
            })}
        </ListOfTopics>
    );
}
